
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://fetlnddyvidcezixqszl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZldGxuZGR5dmlkY2V6aXhxc3psIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgxMDg0MzcsImV4cCI6MjA2MzY4NDQzN30.csZjor-PopjUBOJI561Cx_8N8ZXUBDB-gq8-8P6GuLU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: window.localStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});
